module.exports = __webpack_public_path__ + "static/media/login.bfb560b6.webp";